var RcStrategyService_1;
import { __decorate } from "tslib";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfig } from "../../models/module-config.model";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiRatesCertificateConstants } from "../../constants/api-constants/api-rates-certificate.constants";
import { BehaviorSubject } from "rxjs";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { AppControllerService } from "../../../app-controller.service";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { Router } from "@angular/router";
import { ODataAction } from "../odata-query/odata-action.model";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ViewApplicationDetailsRcComponent } from "../../../view-application/modules/rc/view-application-details-rc/view-application-details-rc.component";
import { ViewApplicationLocationRcComponent } from "../../../view-application/modules/rc/view-application-location-rc/view-application-location-rc.component";
import { CreateApplicationDetailsRcComponent } from "../../../create-application/modules/rc/create-application-details-rc/create-application-details-rc.component";
import { CreateApplicationLocationRcComponent } from "../../../create-application/modules/rc/create-application-location-rc/create-application-location-rc.component";
import { AlertType } from "../../models/alert";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { map } from "rxjs/operators";
import { SharedConstants } from "../../constants/shared.constants";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { ViewApplicationPeopleOfInterestComponent } from "../../../view-application/view-application-people-of-interest/view-application-people-of-interest.component";
import { CreateApplicationPeopleOfInterestComponent } from "../../../create-application/create-application-people-of-interest/create-application-people-of-interest.component";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.CreatedDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export const RCExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_RC;
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export var CreateApplicationRcMenuHeadings;
(function (CreateApplicationRcMenuHeadings) {
    CreateApplicationRcMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationRcMenuHeadings["Location"] = "Property details";
    CreateApplicationRcMenuHeadings["Details"] = "Application details";
    CreateApplicationRcMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationRcMenuHeadings["Agent"] = "Agent";
    CreateApplicationRcMenuHeadings["PeopleOfInterest"] = "People of interest";
    CreateApplicationRcMenuHeadings["Notes"] = "Notes";
    CreateApplicationRcMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationRcMenuHeadings || (CreateApplicationRcMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["PeopleOfInterest"] = "People of interest help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Application summary";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationRcMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationRcMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationRcMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationRcMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationRcMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationRcMenuHeadings.PeopleOfInterest, HeaderConfigurableTextTypes.PeopleOfInterest)
    .set(CreateApplicationRcMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationRcMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationRcMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["Location"] = "Property details";
    ViewApplicationMenuHeadings["Details"] = "Application details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["PeopleOfInterest"] = "People of interest";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.PeopleOfInterest, HeaderConfigurableTextTypes.PeopleOfInterest)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let RcStrategyService = class RcStrategyService extends AflaModuleStrategyService {
    static { RcStrategyService_1 = this; }
    saShortDatePipe;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    applicationCreateService;
    router;
    appController;
    name = ModuleConfig.RatesCertificate;
    applicationEndpoint;
    defaultSearchColumns;
    viewApplicationComponentLookup;
    createApplicationComponentLookup;
    createApplicationMenuHeadings;
    viewApplicationMenuHeadings;
    form;
    applicationServiceUrl = ApiRatesCertificateConstants.URL;
    moduleUsers;
    expandListForApplicationPartial = RCExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    applicationSummaryColumnsMap;
    savedApplication;
    previousApplication = null;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, applicationCreateService, router, appController) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.applicationCreateService = applicationCreateService;
        this.router = router;
        this.appController = appController;
        this.initForm();
        this.applicationEndpoint = `${ApiRatesCertificateConstants.URL}/${ApiRatesCertificateConstants.FUNCTION_GET_MY_AFLA_PORTAL_RC_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationRcMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, RCExpandListForApplicationSearch);
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    buildListFilter(list, column) {
        const params = RcStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_RC_APPLICATIONS_BY_USER;
        }
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsRcComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationRcComponent],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent],
            [ViewApplicationMenuHeadings.PeopleOfInterest, ViewApplicationPeopleOfInterestComponent]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationRcMenuHeadings.Details, CreateApplicationDetailsRcComponent],
            [CreateApplicationRcMenuHeadings.Location, CreateApplicationLocationRcComponent],
            [CreateApplicationRcMenuHeadings.Notes, CreateApplicationNotesComponent],
            [CreateApplicationRcMenuHeadings.PeopleOfInterest, CreateApplicationPeopleOfInterestComponent]
        ]);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationRcMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === CreateApplicationRcMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiRatesCertificateConstants.URL}/${ApiRatesCertificateConstants.FUNCTION_GET_ALL_AFLA_PORTAL_RC_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = RcStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, RcStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appControllerService.showMessage(RcStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                this.resetForm();
                this.router.navigate([AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Add);
            }
        });
    }
    postApplicationService(params) {
        return this.http.post(ApiRatesCertificateConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: RcStrategyService_1.getRecipientName(RcStrategyService_1.getFirstRecipient(application.applicant)),
            agent: RcStrategyService_1.getRecipientName(RcStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate), // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId
        };
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiRatesCertificateConstants.URL}/${applicationId}/${ApiRatesCertificateConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiRatesCertificateConstants.URL}/${applicationId}/${ApiRatesCertificateConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationRcMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildRcDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.PeopleOfInterest.toLocaleLowerCase():
                application = this.buildPeopleOfInterestStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationRcMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                rcApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this as the saved application does not return with the updated family members
                    const params = {
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID} and deleted eq false`,
                        $expand: "applicant,applicantAgent,transferor,transferee,conveyancer,properties($expand=managingAgent($expand=groups)),attachments,notes"
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            this.savedApplication = response.value[0];
                        }, error: (error) => {
                            this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appControllerService.showMessage(RcStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.rcApplication.eLodgementStep;
                                // NB: DO NOT REMOVE THIS LINE UNLESS YOU HAVE A GOOD REASON! OTHERWISE, IT'S GOING TO CAUSE DUPLICATES!!!!
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appControllerService.showMessage(RcStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                },
            });
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationRcMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationRcMenuHeadings.Location.toLocaleLowerCase():
                formName = "propertiesForm";
                break;
            case CreateApplicationRcMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationRcMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationRcMenuHeadings.PeopleOfInterest.toLocaleLowerCase():
                formName = "peopleOfInterestForm";
                break;
            case CreateApplicationRcMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationRcMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationRcMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").reset();
                this.form.get("detailsForm").reset();
                break;
            case CreateApplicationRcMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("propertiesForm").get("properties").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationRcMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationRcMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationRcMenuHeadings.PeopleOfInterest.toLocaleLowerCase():
                this.form.get("peopleOfInterestForm").get("transferor").reset();
                this.form.get("peopleOfInterestForm").get("transferee").reset();
                this.form.get("peopleOfInterestForm").get("conveyancer").reset();
                break;
            case CreateApplicationRcMenuHeadings.Notes.toLocaleLowerCase():
                this.form.get("notesForm").get("note").reset();
                break;
            case CreateApplicationRcMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiRatesCertificateConstants.URL}/${jobId}/GetRcApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("propertiesForm") && this.form.get("propertiesForm").get("properties")) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            if (propertiesArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage("Please select a property before continuing with the create application process", AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage("Please select a property before continuing with the create application process", AlertType.Warning);
            return false;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, Validators.required),
                applicationType: new FormControl(null, Validators.required),
                reasonForApplication: new FormControl(null, Validators.required),
                typeOfTransfer: new FormControl(null, Validators.required),
                propertyType: new FormControl(null, Validators.required),
                ratesAccountNumber: new FormControl(null, Validators.required),
                electronicReference: new FormControl(null, Validators.required),
                attorneyReference: new FormControl(null, Validators.required),
                councilReference: new FormControl(null, Validators.required),
                referenceNumber: new FormControl(null)
            }),
            peopleOfInterestForm: new FormGroup({
                transferor: new FormControl(null, [Validators.required]),
                transferee: new FormControl(null, [Validators.required]),
                conveyancer: new FormControl(null, [Validators.required]),
                copyApplicantToTransferee: new FormControl(false)
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            })
        });
    }
    buildApplication(existingApplication) {
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appControllerService.selectedModuleID),
            eLodgementComplete: false,
            eLodgementStep: 0,
            wkid: 102100
        };
    }
    buildRcDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.type = this.form.get("detailsForm").get("applicationType").value;
            application.description = this.form.get("detailsForm").get("description").value;
            application.reasonForApplication = this.form.get("detailsForm").get("reasonForApplication").value;
            application.typeOfTransfer = this.form.get("detailsForm").get("typeOfTransfer").value;
            application.propertyType = this.form.get("detailsForm").get("propertyType").value;
            application.ratesAccountNumber = this.form.get("detailsForm").get("ratesAccountNumber").value;
            application.electronicReference = this.form.get("detailsForm").get("electronicReference").value;
            application.attorneyReference = this.form.get("detailsForm").get("attorneyReference").value;
            application.councilReference = this.form.get("detailsForm").get("councilReference").value;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appControllerService.selectedModuleID),
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                type: this.form.get("detailsForm").get("applicationType").value,
                description: this.form.get("detailsForm").get("description").value,
                reasonForApplication: this.form.get("detailsForm").get("reasonForApplication").value,
                typeOfTransfer: this.form.get("detailsForm").get("typeOfTransfer").value,
                propertyType: this.form.get("detailsForm").get("propertyType").value,
                ratesAccountNumber: this.form.get("detailsForm").get("ratesAccountNumber").value,
                electronicReference: this.form.get("detailsForm").get("electronicReference").value,
                attorneyReference: this.form.get("detailsForm").get("attorneyReference").value,
                councilReference: this.form.get("detailsForm").get("councilReference").value,
            };
        return application;
    }
    buildLocationStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.properties = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appControllerService.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                properties: [],
                wkid: 102100
            };
        const points = [];
        const propertiesArray = this.form.get("propertiesForm").get("properties");
        const item = propertiesArray.controls[0];
        const centroid = item.get("centroid").value;
        points.push(`(${centroid.x} ${centroid.y})`);
        const geometry = item.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        const managingAgent = item.get("managingAgent").value;
        RecipientUtils.removeInvalidRecipientProperties(managingAgent);
        const extentStringValue = item.get("extent").value;
        const purchasePriceStringValue = item.get("purchasePrice").value;
        const extentDecimalValue = parseFloat(extentStringValue);
        const purchasePriceDecimalValue = parseFloat(purchasePriceStringValue);
        const property = {
            address: item.get("address").value,
            allotment: item.get("allotment").value,
            erfNumber: item.get("erfNo").value,
            farmNumber: item.get("farmNo").value,
            isDummy: false,
            sgCode: item.get("sgCode").value,
            shape: geometryJSON,
            subdivision: item.get("subdivision").value,
            titleDeedNumber: item.get("titleDeedNumber").value,
            zoning: item.get("zoning").value,
            sectionalTitleSchemeName: item.get("sectionalTitleSchemeName").value,
            sectionalTitleSchemeNumber: item.get("sectionalTitleSchemeNumber").value,
            sectionalTitleSchemeUnit: item.get("sectionalTitleSchemeUnit").value,
            extent: extentDecimalValue,
            purchasePrice: purchasePriceDecimalValue,
            dateOfSale: item.get("dateOfSale").value,
            electricityAccountNumber: item.get("electricityAccountNumber").value,
            waterAccountNumber: item.get("waterAccountNumber").value,
            refuseAccountNumber: item.get("refuseAccountNumber").value,
            updateGeometry: false,
            wkid: 102100,
            managingAgent: [managingAgent]
        };
        application.properties = [property];
        application.shape = `MULTIPOINT (${points.join(", ")})`;
        return application;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        if (!applicant.id)
            applicant.id = 0;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appControllerService.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.applicant = [applicant];
        return existingApplication;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        if (existingApplication) {
            existingApplication.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            existingApplication.applicantAgentNa = applicantAgentIsNullValue;
            existingApplication.eLodgementStep = stepIndex;
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appControllerService.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        return application;
    }
    buildPeopleOfInterestStep(stepIndex, existingApplication) {
        let transferee;
        const transfereeFormControlValue = this.form.get("peopleOfInterestForm").get("transferee").value;
        transferee = RecipientUtils.removeInvalidRecipientProperties(transfereeFormControlValue);
        let transferor;
        const transferorFormControlValue = this.form.get("peopleOfInterestForm").get("transferor").value;
        transferor = RecipientUtils.removeInvalidRecipientProperties(transferorFormControlValue);
        let conveyancer;
        const conveyancerFormControlValue = this.form.get("peopleOfInterestForm").get("conveyancer").value;
        conveyancer = RecipientUtils.removeInvalidRecipientProperties(conveyancerFormControlValue);
        const application = existingApplication;
        application.transferee = [transferee];
        application.transferor = [transferor];
        application.conveyancer = [conveyancer];
        application.eLodgementStep = stepIndex;
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: ApplicationCreateService },
        { type: Router },
        { type: AppControllerService }
    ];
};
RcStrategyService = RcStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsubPortal()
], RcStrategyService);
export { RcStrategyService };
